import { APIClient } from "../../helpers/api_helper";
import * as url from "../../helpers/url_helper";

const apiClient = new APIClient();

const INTEREST_CACHE_MONTH_KEY = "currentInterestMonth";
const INTEREST_CACHE_YEAR_KEY  = "currentInterestYear";

function isCacheValid() {
    const now = new Date();
    const cachedMonth = localStorage.getItem(INTEREST_CACHE_MONTH_KEY);
    const cachedYear  = localStorage.getItem(INTEREST_CACHE_YEAR_KEY);
    const currentRate = localStorage.getItem("currentInterestRate");
    const currentTea  = localStorage.getItem("currentInterestTea");

    return (
        currentRate  && currentRate  !== "null" &&
        currentTea   && currentTea   !== "null" &&
        parseInt(cachedMonth) === now.getMonth() + 1 &&
        parseInt(cachedYear)  === now.getFullYear()
    );
}

function saveInterestCache(ted, tea) {
    const now = new Date();
    localStorage.setItem("currentInterestRate",    ted);
    localStorage.setItem("currentInterestTea",     tea);
    localStorage.setItem(INTEREST_CACHE_MONTH_KEY, now.getMonth() + 1);
    localStorage.setItem(INTEREST_CACHE_YEAR_KEY,  now.getFullYear());
}

function parseTeaString(tea) {
    if (!tea) return 0;
    const normalized = String(tea).replace(",", ".");
    const parsed = parseFloat(normalized);
    return isNaN(parsed) || !isFinite(parsed) ? 0 : parsed;
}

export const getInterest = async () => {
    try {
        if (isCacheValid()) {
            return localStorage.getItem("currentInterestRate");
        }
        let response = await apiClient.get(url.GET_RATES_CURRENT_INTEREST);
        const record = response.data.data;
        const interest = record.ted ?? record.tasa ?? null;
        const tea = parseTeaString(record.tea);
        if (interest) saveInterestCache(interest, tea);
        return interest;
    } catch (error) {
        console.log(error);
        return error;
    }
};

export const getAndSetInterestTea = async () => {
    try {
        if (isCacheValid()) {
            return localStorage.getItem("currentInterestTea");
        }
        let response = await apiClient.get(url.GET_RATES_CURRENT_INTEREST);
        const record = response.data.data;
        const interest = record.ted ?? record.tasa ?? null;
        const tea = parseTeaString(record.tea);
        if (interest) saveInterestCache(interest, tea);
        return tea || null;
    } catch (error) {
        console.log(error);
        return;
    }
};